import PromotionModalNotificationContainer from "./promotionModalNotification-container";

const PromotionModalNotification = PromotionModalNotificationContainer;
export default PromotionModalNotification;
